import * as tslib_1 from "tslib";
import { AfterViewInit, ElementRef, OnDestroy, OnInit, QueryList, } from '@angular/core';
import { OwlCarousel } from 'ngx-owl-carousel';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { UniversalPlatformService } from '../shared/platform/universal-platform.service';
import { UniversalRendererHelper } from '../shared/platform/universal-renderer.helper';
import { Utils } from '../shared/utils.class';
import { ObjectUtils } from '../shared/utils/object-utils';
import * as imagesLoaded from 'imagesloaded';
import { ZoomHelper } from '../helpers/zoom-helper';
import { AutoUnsubscribe } from '../decorators/autounsubscribe.decorator';
var ImagesPresentationComponent = /** @class */ (function () {
    function ImagesPresentationComponent(_document, _platformService, _rendererHelper) {
        this._document = _document;
        this._platformService = _platformService;
        this._rendererHelper = _rendererHelper;
        this._classes = {};
        this.disableModal = false;
        this.useImagesLoaded = true;
        this.mainThumbsUseCarousel = false;
        this.currentImageIndex = 0;
        this.currentImageModalIndex = 0;
        this.modalShown = false;
        this.zoomHelper = new ZoomHelper();
        this.preloaded = _platformService.isServer;
        this.currentOwlIndex = 0;
    }
    ImagesPresentationComponent.prototype.ngOnInit = function () {
        this._initOptions();
        this._showThumbs = (this.images || []).length > 1;
    };
    ImagesPresentationComponent.prototype.ngOnDestroy = function () {
        clearInterval(this.owlCheckInterval);
    };
    ImagesPresentationComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        if (this._platformService.isBrowser) {
            var mainImages = this.mainImages.toArray();
            var spliced = mainImages.splice(0, Math.min(4, (mainImages || []).length));
            var preloadedImages = [];
            var len = (spliced || []).length;
            var i = void 0;
            for (i = 0; i < len; ++i) {
                preloadedImages.push(spliced[i].nativeElement);
            }
            var init = function () {
                var checkCount = 0;
                _this.owlCheckInterval = setInterval(function () {
                    ++checkCount;
                    if (checkCount === 120) {
                        clearInterval(_this.owlCheckInterval);
                    }
                    if (_this.owlMain) {
                        if (_this.owlMain.$owlChild && !_this.owlMain.$owlChild.$owl) {
                            _this.owlMain.reInit();
                        }
                        else if (_this.owlMain.$owlChild && _this.owlMain.$owlChild.$owl) {
                            _this.initOwl();
                            clearInterval(_this.owlCheckInterval);
                        }
                    }
                }, 500);
                setTimeout(function () {
                    _this.preloaded = true;
                }, 400);
            };
            if (len > 0) {
                imagesLoaded(preloadedImages, init);
            }
            else {
                init();
            }
        }
    };
    ImagesPresentationComponent.prototype.changeImageByKeyboard = function ($event) {
        if ($event.key === 'ArrowRight') {
            if (!this.modalShown) {
                var index = this.currentImageIndex + 1;
                this.mainGoTo(index, $event);
            }
            else {
                var index = this.currentImageModalIndex + 1;
                this.modalGoTo(index);
            }
        }
        if ($event.key === 'ArrowLeft') {
            if (!this.modalShown) {
                var index = this.currentImageIndex - 1;
                this.mainGoTo(index, $event);
            }
            else {
                var index = this.currentImageModalIndex - 1;
                this.modalGoTo(index);
            }
        }
    };
    ImagesPresentationComponent.prototype.openModal = function (index, evt) {
        if (this.disableModal) {
            if (evt && evt.preventDefault) {
                evt.preventDefault();
            }
            return;
        }
        this.modalGoTo(index, evt);
        this.modal.show();
        this.modalShown = true;
        if (this._showThumbs) {
            this.openThumbs();
            this.closeThumbsIn(1000);
        }
    };
    ImagesPresentationComponent.prototype.closeModal = function (evt) {
        if (evt && evt.preventDefault) {
            evt.preventDefault();
        }
        this.modalShown = false;
        this.modal.hide();
    };
    ImagesPresentationComponent.prototype.mainGoTo = function (index, evt) {
        if (evt && evt.preventDefault) {
            evt.preventDefault();
        }
        if (index >= (this.images || []).length - 1) {
            index = (this.images || []).length - 1;
        }
        if (index <= 0) {
            index = 0;
        }
        this.currentImageIndex = index;
        this.zoomHelper.resetStyles();
        this.owlMain.to([index]);
    };
    ImagesPresentationComponent.prototype.modalGoTo = function (index, evt) {
        if (evt && evt.preventDefault) {
            evt.preventDefault();
        }
        if (this.disableModal) {
            return;
        }
        if (index >= (this.images || []).length - 1) {
            index = (this.images || []).length - 1;
        }
        if (index <= 0) {
            index = 0;
        }
        this.currentImageModalIndex = index;
        this.zoomHelper.resetStyles();
        this.owlModal.to([index]);
        this.currentOwlIndex = index;
        if (this._showThumbs) {
            this.owlThumbs.to([index]);
        }
    };
    ImagesPresentationComponent.prototype.onMouseenterThumbs = function () {
        if (this._showThumbs) {
            this.preventThumbsClose();
            this.openThumbs();
        }
    };
    ImagesPresentationComponent.prototype.onMouseleaveThumbs = function () {
        if (this._showThumbs) {
            this.closeThumbsIn();
        }
    };
    ImagesPresentationComponent.prototype.openThumbs = function () {
        if (this._showThumbs) {
            this._rendererHelper.addClass(this.thumbs, 'show');
        }
    };
    ImagesPresentationComponent.prototype.closeThumbs = function () {
        this.preventThumbsClose();
        this._rendererHelper.removeClass(this.thumbs, 'show');
    };
    ImagesPresentationComponent.prototype.preventThumbsClose = function () {
        clearTimeout(this._closeThumbsTimeout);
    };
    ImagesPresentationComponent.prototype.closeThumbsIn = function (time) {
        var _this = this;
        this._closeThumbsTimeout = setTimeout(function () {
            _this.closeThumbs();
        }, time || 1000);
    };
    ImagesPresentationComponent.prototype.initOwl = function () {
        var _this = this;
        this.owlModal.$owlChild.$owl.on('next.owl.carousel', function () {
            _this.zoomHelper.resetStyles();
        });
        this.owlModal.$owlChild.$owl.on('prev.owl.carousel', function () {
            _this.zoomHelper.resetStyles();
        });
        if (this._platformService.isBrowser) {
            // jQuery time!!!
            if (this.mainThumbsUseCarousel && this.owlMainThumbs) {
                this.owlMainThumbs.$owlChild.$owl.on('translate.owl.carousel', function () {
                    _this._rendererHelper.trigger(_this._document.activeElement, 'blur');
                    _this.zoomHelper.resetStyles();
                });
            }
            if (!this.disableModal) {
                this.owlModal.$owlChild.$owl.on('translate.owl.carousel', function () {
                    _this._rendererHelper.trigger(_this._document.activeElement, 'blur');
                    _this.zoomHelper.resetStyles();
                });
                this.owlThumbs.$owlChild.$owl.on('translate.owl.carousel', function () {
                    _this._rendererHelper.trigger(_this._document.activeElement, 'blur');
                    _this.zoomHelper.resetStyles();
                });
            }
        }
        if (!this.disableModal) {
            this.modal.onShown.subscribe(function () {
                _this.owlModal.refresh();
                _this.owlThumbs.refresh();
                _this._rendererHelper.addClass(_this._document.documentElement, 'has-modal');
                _this._rendererHelper.addClass(_this.modalEl, 'shown');
            });
            this.modal.onHide.subscribe(function () {
                _this._rendererHelper.removeClass(_this._document.documentElement, 'has-modal');
                _this._rendererHelper.removeClass(_this.modalEl, 'shown');
            });
            this.owlModal.$owlChild.$owl.on('translate.owl.carousel', function (evt) {
                _this.currentOwlIndex = evt.item.index;
            });
        }
    };
    ImagesPresentationComponent.prototype._initOptions = function () {
        var _this = this;
        if (!this.options) {
            this.options = {};
        }
        // rozmiar obrazu
        if (typeof this.options.imageSize === 'undefined') {
            this.options.imageSize = 'original';
        }
        // modal
        if (typeof this.options.modalID === 'undefined') {
            this.options.modalID = Utils.uniqid();
        }
        // owl
        if (typeof this.options.owlID === 'undefined') {
            this.options.owlID = Utils.uniqid();
        }
        if (!this.disableModal && typeof this.options.modalOwlID === 'undefined') {
            this.options.modalOwlID = Utils.uniqid();
        }
        if (!this.options.owlMainClasses) {
            this.options.owlMainClasses = [];
        }
        var owlOptions = {
            owlMainOptions: {
                items: 1,
                margin: 20,
                autoHeight: true,
                dots: false,
                nav: false,
                dragEndSpeed: false,
                pullDrag: false,
                touchDrag: true,
                mouseDrag: false,
                autoplay: false,
                center: true,
            },
            owlMainThumbsOptions: {
                items: 6,
                margin: 15,
                dots: false,
                nav: true,
                responsive: {
                    0: {
                        items: 2,
                        margin: 10,
                    },
                    576: {
                        items: 5,
                        margin: 15,
                    },
                    768: {
                        items: 6,
                    },
                    992: {
                        items: 5,
                    },
                    1230: {
                        items: 6,
                    },
                },
                dragEndSpeed: false,
                pullDrag: false,
                touchDrag: true,
                mouseDrag: false,
                autoplay: false,
            },
            owlModalOptions: {
                items: 1,
                margin: 30,
                dots: false,
                nav: true,
                navText: ['', ''],
                navContainer: '#' + this.options.modalID + ' .owl-nav',
                navSpeed: 1500,
                dragEndSpeed: false,
                pullDrag: false,
                touchDrag: true,
                mouseDrag: false,
                autoplay: false,
            },
            owlThumbsOptions: {
                items: 10,
                margin: 10,
                dots: false,
                nav: false,
                responsive: {
                    0: {
                        items: 3,
                    },
                    576: {
                        items: 8,
                    },
                },
                dragEndSpeed: 1000,
                autoplay: false,
            },
        };
        for (var optProp in owlOptions) {
            if (!owlOptions.hasOwnProperty(optProp)) {
                continue;
            }
            this[optProp] = ObjectUtils.extend(true, owlOptions[optProp], this[optProp]);
        }
        // specjalne traktowanie
        this.owlMainOptions.onInitialized = function (evt) {
            if (_this._platformService.isBrowser) {
                setTimeout(function () {
                    var cth = evt.currentTarget.offsetHeight || evt.currentTarget.clientHeight;
                    var os = evt.currentTarget.querySelector('.owl-stage');
                    var osh = os ? (os.offsetHeight || os.clientHeight) : false;
                    if (cth && osh) {
                        if (cth < osh) {
                            _this.owlMain.refresh();
                        }
                    }
                    else {
                        _this.owlMain.reInit();
                    }
                }, 500);
            }
        };
        var owlClasses = {
            owlMainClasses: ['owl-carousel', 'owl-theme', 'art-presentation'],
            owlModalClasses: ['owl-carousel', 'owl-theme', 'art-presentation', 'art-modal-presentation'],
            owlThumbsClasses: ['art-thumbs-list', 'art-thumbs-modal-list', 'owl-carousel', 'owl-theme'],
            thumbsClasses: ['art-thumbs'],
            thumbsListClasses: ['art-thumbs-list'],
        };
        var cls;
        for (var clsProp in owlClasses) {
            if (!owlClasses.hasOwnProperty(clsProp)) {
                continue;
            }
            cls = owlClasses[clsProp];
            if (typeof this.options[clsProp] === 'undefined') {
                this.options[clsProp] = [];
            }
            for (var i = 0; i < (cls || []).length; ++i) {
                if (this.options[clsProp].indexOf(cls[i]) === -1) {
                    this.options[clsProp].push(cls[i]);
                }
            }
            this._classes[clsProp] = this.options[clsProp].join(' ');
        }
    };
    ImagesPresentationComponent = tslib_1.__decorate([
        AutoUnsubscribe(),
        tslib_1.__metadata("design:paramtypes", [Object, UniversalPlatformService,
            UniversalRendererHelper])
    ], ImagesPresentationComponent);
    return ImagesPresentationComponent;
}());
export { ImagesPresentationComponent };
